import React, { Component } from 'react';
import fire from '../fire';
import { Grid, Form } from 'semantic-ui-react';

class AddContact extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name:"",
      comment: ""
    };
  }

  postContact = () => {
    const contactsRef = fire.database().ref('contacts');

    const item = {
      name: this.state.name,
      date: new Date().toLocaleString(),
      comment: this.state.comment
    }

    contactsRef.push(item);

    this.setState({
      name:"",
      comment: ""
    });
  }

  handleChange = (e, { name, value }) => {
    this.setState({ 
      [name]: value
    })
  }

  render() {
    return (
      <Grid centered>
        <Grid.Column mobile={15} computer={10} tablet={12}>
          <Form onSubmit={this.postContact} size="mini">
              <Form.Input name="name" type="text" value={this.state.name} placeholder='Enter a Name (Optional)' onChange={this.handleChange}/>
              <Form.TextArea required name="comment" type="text" value={this.state.comment} placeholder='Enter a Comment' onChange={this.handleChange} />
              <Form.Button content='Submit' secondary/>
          </Form>
        </Grid.Column>
      </Grid>
    );
  }
}
export default AddContact;
